import React, { useContext } from "react";
import PropTypes from "prop-types";
import { InvoiceTemplateContext } from "../InvoiceTemplateContext";

const ValuePlaceholder = props => {
  const { showValuePlaceHolder } = useContext(InvoiceTemplateContext);

  if (showValuePlaceHolder) {
    const placeholder = `{{${props.placeholderKey}}}`;
    return <>{placeholder}</>;
  }

  return <>{props.children}</>;
};

ValuePlaceholder.propTypes = {
  children: PropTypes.node,
  placeholderKey: PropTypes.string,
};

export default ValuePlaceholder;
